import WrapperService from "@/modules/core/services/wrapper-service";
import { createPageableParams } from "@/modules/core/services/table-utils";
import FacilityTechnicalStateWrapper from "@/modules/book/data/facility-technical-state-wrapper";
import store from '@/store';

const sortPublicProcessResultFields = ["finishedOn", "processName", "rideCount"];
const sortPublicProcessResultDatabaseFields = ["finishedOn", "p.name", "rideCount"];

const sortPublicProcessJobFields = ["processName", "badge", "assignedToName", "assignedToRoleName"];
const sortPublicProcessJobDatabaseFields = ["p.name", "accepted", "assigned_to", "p.role"];

const sortFacilityDocumentationFields = ["translatedType"];
const sortFacilityDocumentationDatabaseFields = [""];

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/qrcode"
const API_URL_PUBLIC = process.env.VUE_APP_ROOT_API + "/api/v1/public/qrcode";
const API_URL_QRCODE = process.env.VUE_APP_BOOK_DOMAIN + '/' + store.state.manager.bookModuleUrl + "/public/qrcode";

const serviceName = "QRCode-Service: ";
export default class QRCodeService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllUnusedFromAPI(ownFacilityId, successF, errorF) {
    if (!ownFacilityId) ownFacilityId = "";

    var params = new URLSearchParams();
    params.append("ownFacilityId",ownFacilityId);
    
    await WrapperService.get(API_URL + "/unused", {params: params}, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static putToAPI(qrcode, successF, errorF) {
    WrapperService.put(API_URL + "/" + qrcode.id, qrcode, serviceName, successF, errorF);
  }

  static async createQRCodes(name, count, customer, start, successF, errorF){
    let formData = new FormData();
    formData.append("name", name)
    formData.append("count", count);
    formData.append("customer", customer);
    formData.append("start", start);
    WrapperService.post(API_URL + "/create", formData, serviceName, successF, errorF);
  }

  static importCsv(file, successF, errorF) {
    let formData = new FormData();
    // files
    formData.append("csv", file, file.name);
    WrapperService.post(API_URL + "/import/csv", formData, serviceName, successF, errorF);
  }

  static async readCodeFromPublic(code, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/" + code, null, serviceName, successF, errorF);
  }

  static async readFacilitiesFromPublic(code, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/facilities", null, serviceName, successF, errorF);
  }

  static assignFacilityToCode(code, facility, successF, errorF){
    WrapperService.put(API_URL_PUBLIC + "/" + code + "/facilities/" + facility.id, null, serviceName, successF, errorF);
  }

  static async readDataFromPublic(code, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/data", null, serviceName, successF, errorF);
  }

  static async readPageableResultsFromPublic(code, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortPublicProcessResultFields, sortPublicProcessResultDatabaseFields);
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/results", { params: params}, serviceName, successF, errorF);
  }

  static async readPageableJobsFromPublic(code, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortPublicProcessJobFields, sortPublicProcessJobDatabaseFields);
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/jobs", {params: params}, serviceName, successF, errorF);
  }

  static async takeoverJob(code, jobId, successF, errorF) {
    await WrapperService.put(API_URL_PUBLIC + "/" + code + "/jobs/" + jobId + "/takeover", null, serviceName, successF, errorF);
  }

  static getPublicURL(){
    return API_URL_QRCODE;
  }

  static saveOnboarding(facility, technicalInfo, facilityState, successF, errorF) {
    let fts = new FacilityTechnicalStateWrapper();
    fts.facilityStateDto = facilityState;
    fts.technicalInfoDto = technicalInfo;
    return WrapperService.put(API_URL_PUBLIC + '/onboarding/' + facility.id, fts, serviceName, successF, errorF);
  }

  static postFacilityDocumentationToAPI(qrCode, file, facilityDocumentation, successF, errorF) {
    let formData = new FormData();
    // files
    formData.append("media", file, file.name);
    // additional data
    formData.append("name", facilityDocumentation.name);
    formData.append("start", facilityDocumentation.start);
    formData.append("end", facilityDocumentation.end);
    formData.append("type", facilityDocumentation.type);

    WrapperService.post(API_URL_PUBLIC + "/" + qrCode + "/documentation", formData, serviceName, successF, errorF);
  }

  static async readPageableFacilityDocumentationsFromAPI(code, page, size, search, filter, docuTypeCat, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortFacilityDocumentationFields, sortFacilityDocumentationDatabaseFields);
    params.append("filterBy", filter)
    params.append("docuTypeCategory", docuTypeCat )
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/documentations", {params: params}, "Documentation-Service: ", successF, errorF);
  }

  static async readFacilityDocumentationScoreForFacility(code, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/documentations/score", null, serviceName, successF, errorF);
  }

  static async readRequiredDocumentaitonsForFacilityFromAPI(code, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/" + code + "/documentations/required", null, serviceName, successF, errorF);
  }

  static async readConnectableFacilities(facilityId, successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/facilities/connectable/" + facilityId, null, serviceName, successF, errorF);
  }

}
